<template>
    <el-row>
        <el-col :span="7">
            <el-select v-model="addList.provinceid" placeholder="请选择省" class="address_select"
                @change="getcity(addList.provinceid,true)">
                <el-option v-for="(item,index) in sheng" :key="index" :label="item" :value="index" :data-aa="index">
                </el-option>
            </el-select>
        </el-col>
        <el-col :span="7" :offset='1'>
            <el-select v-model="addList.city" placeholder="请选择市" class="address_select"
                @change="getarea(addList.city,true)">
                <el-option v-for="(item,index) in shi" :key="index" :label="item" :value="index">
                </el-option>
            </el-select>
        </el-col>
        <el-col :span="7" :offset='1'>
            <el-select v-model="addList.area" placeholder="请选择区" class="address_select" @change="postData()">
                <el-option v-for="(item,index) in qu" :key="index" :label="item" :value="index">
                </el-option>
            </el-select>
        </el-col>
    </el-row>
</template>
<script>
import addr from '../../utils/city.js';
export default {
    name: "city",
    data () {
        return {
            addList:[],
            addListText:[],
            sheng: {},
            shi: {},
            qu: {},
        };
    },
    props: {
        addrVal:{
            type:Object
        }
    },
    mounted(){
        this.getsheng();
    },
    methods: {
        // 获取省
        getsheng () {
            this.sheng = addr.province_list;
            this.postData();
        },
        // 点击地区获取市
        getcity (id, is) {
            if (is) {
                //判断是否点击上一级
                this.addList.area = "";
                this.addList.city = "";
            }

            let city_arr = {};
            for( let q in addr.city_list ){
                if( id.slice(0,2) == q.slice(0,2) ){
                    city_arr[q] = addr.city_list[q];
                }
            }

            this.shi = city_arr;
            this.postData();
        },
        // 点击城市获取区
        getarea (id, is) {
            if (is) {
                //判断是否点击上一级
                this.addList.area = "";
            }

            let area_arr = {};
            for( let q in addr.county_list ){
                if( id.slice(0,4) == q.slice(0,4) ){
                    area_arr[q] = addr.county_list[q];
                }
            }
            this.qu  = area_arr;
        },
        // 向父组件传值
        postData () {
            let _this = this;
            let sheng = this.sheng;
            let shi = this.shi;
            let qu = this.qu;
            this.$forceUpdate();

            let addrArrText = [];

            addrArrText[0] = _this.sheng[_this.addList['provinceid']];
            addrArrText[1] = _this.shi[_this.addList['city']];
            addrArrText[2] = _this.qu[_this.addList['area']];
            addrArrText[3] = _this.addList;
            setTimeout(function () {
                _this.$emit("addlist", addrArrText);
            }, 10);
        }
    },
    watch: {
        //监听父组件传值的变化
        addrVal() {
            if( this.addrVal.province ){
                this.addList = {
                    provinceid: this.addrVal.province,
                    city: this.addrVal.city,
                    area: this.addrVal.county
                }
                // var arr = this.addrVal.company_address.split('-');
                // this.addList = {
                //     provinceid: arr[0],
                //     city: arr[1],
                //     area: arr[2]
                // }
            }

        }
    }
}
</script>
<style lang="stylus">
.el-input--mini .el-input__inner
    height 40px
.el-form-item--mini .el-form-item__label
    line-height 40px
</style>



// WEBPACK FOOTER //
// src/components/common/city.vue